import React from "react";
import { Formik } from "formik";
import { object } from "yup";
import { Col } from "react-bootstrap";
import { Api } from "../../utils/api";
import { MaterialSelect } from "../../components/select-field.component";
import Button from "@material-ui/core/Button/Button";

const validationSchema = object().shape({});

const handleSubmitting = (fn) => (values, actions) => {
  fn(values.admin_id);
  actions.setSubmitting(false);
};

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.email, label: option.name }));
};

export const adminOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/admins", { admin_group_ids: [5], active: true })
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const DashboardFilterForm = ({ admin_id, onChange }) => (
  <Col>
    <Formik
      initialValues={{
        admin_id: admin_id || "",
      }}
      onSubmit={handleSubmitting(onChange)}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      render={({ values, handleSubmit, setFieldValue, setFieldTouched }) => {
        return (
          <>
            <form onSubmit={handleSubmit}>
              <MaterialSelect
                name="admin_id"
                placeholder="admin_id"
                label="Colaborador"
                onBlur={setFieldTouched}
                onChange={setFieldValue}
                optionsFetcher={adminOptionsPromise}
                value={"" + values.admin_id}
              />
              <Button variant="contained" type="submit" size="small">
                Filtrar
              </Button>
            </form>
          </>
        );
      }}
    />
  </Col>
);
